import { useCallback, useRef } from 'react'

export function useRefWithCallback<T extends HTMLElement>(onMount: (node: T) => void, onUnmount?: (node: T) => void) {
  const nodeRef = useRef<T | null>(null)

  return useCallback(
    (node: T) => {
      if (nodeRef.current && onUnmount) {
        onUnmount(nodeRef.current)
      }

      nodeRef.current = node

      if (nodeRef.current) {
        onMount(nodeRef.current)
      }
    },
    [onMount, onUnmount]
  )
}
